import { useEffect, useState } from 'react';
import { useCoupons } from '../hooks/use-coupons';
import { COUPON_ITEM_CLASS_NAME } from '../constants';
import LoadingDialog from 'components/loading-dialog';

import { CircularLoading } from 'respinner';
import isEmpty from 'lodash/isEmpty';
import { CouponList } from '../components/coupon-list';
import { EmptyState } from '../components/empty-state/empty-state';
import { ErrorMessage } from '../components/error-message';
import { registerInViewEvent } from "../../../helpers/register-inview-event";

import styles from './expired-page.module.sass';

export function ExpiredPage() {
  const { coupons, next, status } = useCoupons({ state: ['expired', 'all_redeemed'] });

  useEffect(() => {
    const lastItem = document.querySelector(`.${COUPON_ITEM_CLASS_NAME}:last-child`)

    const unregister  = registerInViewEvent(lastItem, next)

    return unregister;  
  }, [coupons, next]);

  if (status === 'fetching' && coupons.length === 0) return <LoadingDialog isShow/>;


    if (status === 'error') {
      return (
        <ErrorMessage
          type="failure"
          isShow
          autoDismiss={false}
          onDismiss={() => {
            window.location.reload();
          }}
        >
          有東西出錯了，請點擊以重新整理
        </ErrorMessage>
      );
    }

  return (
    <div className={styles.root}>
      <h3 className={styles.title}>序號兌換</h3>
      <p className={styles.desc}>已使用／已過期的優惠券</p>
      <div className={styles.container}>
        {isEmpty(coupons) ? <EmptyState content="無已失效優惠券" /> : <CouponList coupons={coupons} type="expired" />}
        {status === 'fetching' && <CircularLoading className={styles.loading} size={24} duration={1} />}
      </div>
    </div>
  );
}
